import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { BookerContext } from '../Booker/index.js';
import { Button } from 'ui';
const Counter = ({ children }) => {
    const { useTailwindPrefix } = useContext(BookerContext);
    return (_jsx("div", Object.assign({ className: classNames({
            'py-2.5 px-0 flex items-center': !useTailwindPrefix,
            'tw-py-2.5 tw-px-0 tw-flex tw-items-center': useTailwindPrefix,
        }) }, { children: children })));
};
const Label = ({ children }) => {
    const { useTailwindPrefix } = useContext(BookerContext);
    return (_jsx("div", Object.assign({ className: classNames({
            'flex-grow inline-block': !useTailwindPrefix,
            'tw-flex-grow tw-inline-block': useTailwindPrefix,
        }) }, { children: children })));
};
const Spacer = () => {
    const { useTailwindPrefix } = useContext(BookerContext);
    return (_jsx("div", { className: classNames({
            'h-[30px] inline-block': !useTailwindPrefix,
            'tw-h-[30px] tw-inline-block': useTailwindPrefix,
        }) }));
};
export const ServiceBookerLoading = () => {
    const { useTailwindPrefix } = useContext(BookerContext);
    const intl = useIntl();
    return (_jsxs("div", { children: [_jsx("div", Object.assign({ className: classNames({ 'mb-2.5': !useTailwindPrefix, 'tw-mb-2.5': useTailwindPrefix }) }, { children: intl.formatMessage({ id: 'booker.dayPass.chooseDate' }) })), _jsx("div", Object.assign({ className: classNames({
                    'border py-[13px] px-3 mb-2.5 text-transparent': !useTailwindPrefix,
                    'tw-border tw-py-[13px] tw-px-3 tw-mb-2.5 tw-text-transparent': useTailwindPrefix,
                }) }, { children: intl.formatMessage({ id: 'booker.dayPass.date' }) })), _jsxs(Counter, { children: [_jsx(Label, { children: intl.formatMessage({ id: 'booker.adults' }) }), _jsx(Spacer, {})] }), _jsxs(Counter, { children: [_jsxs(Label, { children: [intl.formatMessage({ id: 'booker.minors' }), _jsxs("div", Object.assign({ className: classNames({
                                    'text-[85%] text-zinc-400': !useTailwindPrefix,
                                    'tw-text-[85%] tw-text-zinc-400': useTailwindPrefix,
                                }) }, { children: ["0 -", ' '] }))] }), _jsx(Spacer, {})] }), _jsx(Button, Object.assign({ className: classNames({ 'w-full': !useTailwindPrefix, 'tw-w-full': useTailwindPrefix }), disabled: true }, { children: intl.formatMessage({ id: 'booker.dayPass.continue' }) }))] }));
};
